export default function errorResultParser(errors) {
	return Object.values(errors).join('/n');
}
